import { useState, useRef, useEffect, useContext } from "react";
import { FaEllipsisV, FaEdit, FaTrashAlt } from "react-icons/fa";
import { ThemeContext } from "../../../../theme/ThemeContext";

const DocTypeCard = ({ title, onEdit, onDelete }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const getInitials = (text) => {
    if (!text) return "";
    let cleanText = text.replace(/\(.*?\)/g, "");
    cleanText = cleanText.replace(/[0-9-]/g, "").trim();
    const words = cleanText.split(" ").filter(Boolean);
    const first = words[0]?.charAt(0) || "";
    const last = words.length > 1 ? words[words.length - 1]?.charAt(0) : "";
    return (first + last).toUpperCase();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleMenu = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const dropdownHeight = 100;
      setDropUp(spaceBelow < dropdownHeight);
    }
    setShowMenu(!showMenu);
  };

  return (
    <div
      className="card border-0 shadow-sm p-3 h-100 d-flex flex-row align-items-center justify-content-between"
      style={{ cursor: "pointer", minHeight: "100px" }}
    >
      <div className="d-flex flex-row align-items-center gap-3">
        <div
          className="rounded-circle  d-flex justify-content-center align-items-center text-dark "
          style={{ width: "45px", height: "45px", flexShrink: 0, backgroundColor: '#BDCBDB' }}
        >
          {getInitials(title)}
        </div>
        <h6 className="mb-0 lh-base">{title}</h6>
      </div>

      {(onEdit || onDelete) && (
        <div className="position-relative" ref={menuRef}>
          <button
            className="btn btn-sm border-0"
            ref={buttonRef}
            onClick={(e) => {
              e.stopPropagation();
              toggleMenu();
            }}
          >
            <FaEllipsisV
              size={18}
              className="fw-normal"
              color={isDark ? "#ffffff" : "#000000"}
            />
          </button>

          {showMenu && (
            <div
              className={`position-absolute end-0 ${dropUp ? "mb-2 bottom-100" : "mt-2"}`}
              style={{
                minWidth: "160px",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(6px)",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                zIndex: 1000,
                padding: "8px 0",
              }}
            >
              {onEdit && (
                <button
                  className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu(false);
                    onEdit();
                  }}
                  style={{ fontSize: "14px", color: "#333" }}
                >
                  <FaEdit size={14} /> Edit
                </button>
              )}
              {onDelete && (
                <button
                  className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowMenu(false);
                    onDelete();
                  }}
                  style={{ fontSize: "14px", color: "#e63946" }}
                >
                  <FaTrashAlt size={14} /> Delete
                </button>
              )}
            </div>
          )}
        </div>
      )}


    </div>
  );
};

export default DocTypeCard;
